import { render, staticRenderFns } from "./MonthlyActivityChart.vue?vue&type=template&id=944bc1fa&scoped=true&"
import script from "./MonthlyActivityChart.vue?vue&type=script&lang=ts&"
export * from "./MonthlyActivityChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944bc1fa",
  null
  
)

export default component.exports